import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-14e7c208")

_pushScopeId("data-v-14e7c208")
const _hoisted_1 = { class: "bi-wrap cce-panel-wrap flex justify-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("下一步")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_slider = _resolveComponent("a-slider")
  const _component_a_rate = _resolveComponent("a-rate")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_UploadImg = _resolveComponent("UploadImg")
  const _component_a_button = _resolveComponent("a-button")
  const _component_Col = _resolveComponent("Col")
  const _component_Row = _resolveComponent("Row")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_spin = _resolveComponent("a-spin")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, {
      spinning: _ctx.basicInfo.saving.value||_ctx.basicInfo.quering.value
    }, {
      default: _withId(() => [
        _createVNode(_component_a_form, {
          style: {"width":"550px"},
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol,
          rules: _ctx.basicInfo.rules
        }, {
          default: _withId(() => [
            _createVNode(_component_a_form_item, { label: "案例名称" }, {
              default: _withId(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.basicInfo.formState.caseName,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.basicInfo.formState.caseName = $event)),
                  maxlength: 20
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "案例模块" }, {
              default: _withId(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.basicInfo.formState.caseModule,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.basicInfo.formState.caseModule = $event))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.caseModules, (caseModule, caseModuleIndex) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: caseModule,
                        value: caseModuleIndex
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(caseModule), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "案例单元" }, {
              default: _withId(() => [
                _createVNode(_component_a_slider, {
                  marks: _ctx.caseUnits,
                  step: 1,
                  max: _ctx.caseUnits.length - 1,
                  "tip-formatter": _ctx.caseUnitFormatter,
                  value: _ctx.basicInfo.formState.caseUnit,
                  range: "",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.basicInfoController.handleCaseUnitChange($event)))
                }, null, 8, ["marks", "max", "tip-formatter", "value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "案例难度" }, {
              default: _withId(() => [
                _createVNode(_component_a_rate, {
                  value: _ctx.basicInfo.caseDifficulty.value,
                  "allow-half": "",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.basicInfo.setCaseDifficulty($event)))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "案例信息" }, {
              default: _withId(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.basicInfo.formState.caseInfomation,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.basicInfo.formState.caseInfomation = $event)),
                  maxlength: 300
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "案例封面" }, {
              default: _withId(() => [
                _createVNode(_component_UploadImg, {
                  urlsrc: _ctx.basicInfo.formState.caseImg,
                  onUpload: _cache[6] || (_cache[6] = ($event: any) => (_ctx.basicInfoController.handleImgUpload($event)))
                }, null, 8, ["urlsrc"])
              ]),
              _: 1
            }),
            _createVNode(_component_Row, null, {
              default: _withId(() => [
                _createVNode(_component_Col, { offset: "4" }, {
                  default: _withId(() => [
                    _createVNode(_component_a_button, {
                      class: "mr18",
                      type: "primary",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.basicInfoController.handleSave())),
                      loading: _ctx.basicInfo.saving.value
                    }, {
                      default: _withId(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_a_button, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.basicInfoController.handleNext()))
                    }, {
                      default: _withId(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label-col", "wrapper-col", "rules"])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
})